export const MESSAGE_COLlECTION = "messages";
export const CONVERSATION_COLlECTION = "conversations";
export const USER_COLlECTION = "users";
